const styles = () => ({
  spinner: {},
});

export default styles;
